var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalArchive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1697_165)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.875 12.1875V4.6875C1.875 2.10277 3.97777 0 6.5625 0H13.5938C15.8794 0 17.7878 1.64437 18.1989 3.81216C20.4228 4.17703 22.125 6.11203 22.125 8.4375V12.1875C22.0789 13.4301 20.2957 13.4291 20.25 12.1875V8.4375C20.25 6.88669 18.9883 5.625 17.4375 5.625H10.4062C8.85544 5.625 7.59375 6.88669 7.59375 8.4375V12.1875C7.54767 13.4301 5.76441 13.4291 5.71875 12.1875V8.4375C5.71875 5.85277 7.82152 3.75 10.4062 3.75H16.245C15.858 2.65884 14.8159 1.875 13.5938 1.875H6.5625C5.01169 1.875 3.75 3.13669 3.75 4.6875V12.1875C3.70392 13.4301 1.92066 13.4291 1.875 12.1875ZM24 18.1406V18.375C24 21.4766 21.4766 24 18.375 24H5.625C2.52338 24 0 21.4766 0 18.375V18.1406C0 16.3313 1.47197 14.8594 3.28125 14.8594H6.32259C7.74731 14.8594 9.06647 15.6722 9.68344 16.9302C10.5905 18.8445 13.4099 18.8438 14.3166 16.9302C14.9335 15.6722 16.2527 14.8594 17.6774 14.8594H20.7188C22.528 14.8594 24 16.3313 24 18.1406ZM22.125 18.1406C22.125 17.3652 21.4942 16.7344 20.7188 16.7344H17.6774C16.9628 16.7344 16.3043 17.1353 16 17.7558C15.6387 18.4925 15.0812 19.115 14.388 19.5561C12.97 20.4775 11.0299 20.4775 9.612 19.5561C8.91872 19.115 8.36123 18.4925 7.99997 17.7558C7.69566 17.1353 7.0372 16.7344 6.32255 16.7344H3.28125C2.50584 16.7344 1.875 17.3652 1.875 18.1406V18.375C1.875 20.4427 3.55725 22.125 5.625 22.125H18.375C20.4427 22.125 22.125 20.4427 22.125 18.375V18.1406Z",
    fill: "#202020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0937 9.375H10.4062C9.16362 9.32892 9.16455 7.54566 10.4062 7.5H15.0937C16.3362 7.54608 16.3353 9.32934 15.0937 9.375ZM13.6874 12.1875C13.6874 11.6697 13.2677 11.25 12.7499 11.25H10.4062C9.16362 11.2961 9.16455 13.0793 10.4062 13.125H12.7499C13.2677 13.125 13.6874 12.7053 13.6874 12.1875Z",
    fill: "#202020"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1697_165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalArchive);
export default __webpack_public_path__ + "static/media/medical-archive.74293f5edf6f2060a6fe352adeb2816c.svg";
export { ForwardRef as ReactComponent };